import React, { useLayoutEffect, useRef, useState } from "react";

const formatCompact = (num) => {
  const n = Number(num) || 0;
  if (Math.abs(n) >= 1000000) return `${(n / 1000000).toFixed(1).replace(/\.0$/, "")}M`;
  if (Math.abs(n) >= 1000) return `${(n / 1000).toFixed(1).replace(/\.0$/, "")}K`;
  return Math.round(n).toLocaleString();
};

const FitNumber = ({ value, text, prefix = "", className = "" }) => {
  const boxRef = useRef(null);
  const measureRef = useRef(null);
  const [compact, setCompact] = useState(false);
  const full = text ?? `${prefix}${(Number(value) || 0).toLocaleString()}`;

  useLayoutEffect(() => {
    const box = boxRef.current;
    const measure = measureRef.current;
    if (!box || !measure) return undefined;
    const check = () => setCompact(measure.offsetWidth > box.clientWidth);
    check();
    if (typeof ResizeObserver === "undefined") return undefined;
    const observer = new ResizeObserver(check);
    observer.observe(box);
    return () => observer.disconnect();
  }, [full]);

  return (

    <span
      ref={boxRef}
      className={`relative block w-full whitespace-nowrap ${className}`}
      title={(Number(value) || 0).toLocaleString()}
    >
      {compact ? `${prefix}${formatCompact(value)}` : full}
      <span
        ref={measureRef}
        aria-hidden="true"
        className="absolute invisible whitespace-nowrap left-0 top-0 h-0 overflow-hidden"
      >
        {full}
      </span>
    </span>
  );
};

export default FitNumber;
